import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home';
import { AuthGuard } from './_helpers';

const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const usersModule = () => import('./users/users.module').then(x => x.UsersModule);
const adminModule = () => import('./admin/admin.module').then(x => x.AdminModule);
const productsModule = () => import('./products/products.module').then(x => x.ProductsModule);
const categoriesModule = () => import('./categories/categories.module').then(x => x.CategoriesModule);
const masterModule = () => import('./master/master.module').then(x => x.MasterModule);
const customersModule = () => import('./contacts/contact.module').then(x => x.ContactsModule);
const expensesModule = () => import('./expenses/expense.module').then(x => x.ExpensesModule);
const salesModule = () => import('./sales/sales.module').then(x => x.SalesModule);
const reportsModule = () => import('./reports/reports.module').then(x => x.ReportsModule);
const ledgerModule = () => import('./ledger/ledger.module').then(x => x.LedgerModule);
const purchaseModule = () => import('./purchase/purchase.module').then(x => x.PurchaseModule);
const purchaseReturnModule = () => import('./purchase-return/purchase-return.module').then(x => x.PurchaseReturnModule);
const supplierCreditNoteModule = () => import('./supplier-credit-note/supplier-credit-note.module').then(x => x.SupplierCreditNoteModule);
const wholesaleModule = () => import('./wholesale/wholesale.module').then(x => x.WholesaleModule);
const transporterModule = () => import('./transporter/transporter.module').then(x => x.TransporterModule);
const attendanceModule = () => import('./attendance/attendance.module').then(x => x.AttendanceModule);
const payrollModule = () => import('./payroll/payroll.module').then(x => x.PayrollModule);

const routes: Routes = [
    { path: '', component: HomeComponent, canActivate: [AuthGuard] },

    // ✅ SuperAdmin Panel (Accessible only for SuperAdmin)
    { 
        path: 'admin', 
        loadChildren: adminModule, 
        canActivate: [AuthGuard]
    },

    // ✅ Users & Masters (Accessible only for Admin (1) or Manager (3))
    { 
        path: 'users', 
        loadChildren: usersModule, 
        canActivate: [AuthGuard]
    },
    { 
        path: 'masters', 
        loadChildren: masterModule, 
        canActivate: [AuthGuard]
    },

    // ✅ Accessible for all authenticated users
    { path: 'products', loadChildren: productsModule, canActivate: [AuthGuard] },
    { path: 'categories', loadChildren: categoriesModule, canActivate: [AuthGuard] },
    { path: 'customers', loadChildren: customersModule, canActivate: [AuthGuard] },
    { path: 'expenses', loadChildren: expensesModule, canActivate: [AuthGuard] },
    { path: 'sales', loadChildren: salesModule, canActivate: [AuthGuard] },
    { path: 'reports', loadChildren: reportsModule, canActivate: [AuthGuard] },
    { path: 'ledger', loadChildren: ledgerModule, canActivate: [AuthGuard] },
    { path: 'purchase', loadChildren: purchaseModule, canActivate: [AuthGuard], data: { allowAllUsers: true } },
    { path: 'purchase-return', loadChildren: purchaseReturnModule, canActivate: [AuthGuard] },
    { path: 'supplier-credit-notes', loadChildren: supplierCreditNoteModule, canActivate: [AuthGuard] },
    { path: 'wholesale', loadChildren: wholesaleModule, canActivate: [AuthGuard] },
    
    // ✅ Attendance module for employee attendance tracking
    { path: 'attendance', loadChildren: attendanceModule, canActivate: [AuthGuard] },

    // ✅ Payroll module (salary structure + computed net-sale incentive payroll)
    // Permission check is done per-child-route (see payroll-routing.module.ts) since
    // "My Salary" should be reachable by anyone with Attendance access, not just Payroll.
    { path: 'payroll', loadChildren: payrollModule, canActivate: [AuthGuard], data: { allowAllUsers: true } },
    
    // ✅ Transporter module (Only for transporter users)
    { path: 'transporter', loadChildren: transporterModule, canActivate: [AuthGuard] },
    
    // ✅ Account module without authentication (Login/Register)
    { path: 'account', loadChildren: accountModule },

    // ✅ Fallback route (Redirect to home)
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule { }